import * as React from 'react';

import {
    Container,
    Stack,
} from '@mui/material';

import BackButton from '../../../Components/Shared/BackButton';
import ShowStudentEvaluationButton from '../../../Components/StudentEvaluation/ShowStudentEvaluationButton';

import ExperimentStudentDetailsHeader from './ExperimentStudentDetailsHeader';

import { DownloadStatsButton } from '../DownloadStats';

import { StudentExperimentProgress, TeacherStudentExperimentProgress, Evaluation } from '../../../../App/API/Experiments';
import { Scenario, ScenarioStep } from '../../../../App/Store/SimpleCreateExperiment/Types';

import ExperimentStudentDetailsTimeLine from './ExperimentStudentDetailsTimeLine';

type ExperiementStudentDetailsContentProps = {
    student: TeacherStudentExperimentProgress['Student'],
    experimentProgress: {
        scenario: Scenario;
        steps: ScenarioStep[];
        progress: StudentExperimentProgress | TeacherStudentExperimentProgress;
    },
    experimentId: number
    evaluation: Evaluation;
}

export default function ExperiementStudentDetailsContent({ student, experimentProgress, experimentId, evaluation } : ExperiementStudentDetailsContentProps)
{
    return (
        <>
            <Container maxWidth='lg'>
                <BackButton />
            </Container>
            <Container maxWidth='xl'>
                <ExperimentStudentDetailsHeader
                    scenario = { experimentProgress.scenario }
                    student = { student }
                />
            </Container>
            <Container>
                <Stack
                >
                    {evaluation && <ShowStudentEvaluationButton evaluation={evaluation}></ShowStudentEvaluationButton>}
                </Stack>

                <Stack
                    direction='row-reverse'
                >
                    {
                        experimentProgress?.progress?.completed &&
                        <DownloadStatsButton 
                            student = { student }
                            experimentId = { experimentId }
                        />
                    }
                </Stack>

                <ExperimentStudentDetailsTimeLine
                    experimentProgress={ experimentProgress }
                />
            </Container>
        </>
    )
}